module.exports = __webpack_public_path__ + "static/media/courses.a9260be9.svg";